import clsx from 'clsx'
import Map from '@/src/components/elements/Map'

export default function MeetupMap(props: Parameters<typeof Map>[0]) {
  const className = clsx(props.className, 'h-full w-full')
  return (
    <div className="aspect-w-1 flex overflow-hidden rounded-2xl aspect-h-1 md:aspect-w-2">
      <div>
        <Map {...props} className={className} />
      </div>
    </div>
  )
}
